import { useEffect, useState } from "react";
import api from "@/lib/api";

const MAX_ATTEMPTS = 10;
const INTERVAL_MS = 2000;

const statusFrom = (data) => {
  if (data.payment_status === "paid") return "paid";
  if (data.status === "expired") return "expired";
  return null;
};

export function usePaymentStatus(sessionId, enabled) {
  const [status, setStatus] = useState("polling");
  const [kind, setKind] = useState("promote");

  useEffect(() => {
    if (!enabled || !sessionId) return;
    let timer;
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      if (attempts > MAX_ATTEMPTS) { setStatus("timeout"); return; }
      const data = await api.get(`/payments/checkout/status/${sessionId}`).then((r) => r.data).catch(() => ({}));
      if (data.kind) setKind(data.kind);
      const final = statusFrom(data);
      if (final) setStatus(final);
      else timer = setTimeout(poll, INTERVAL_MS);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId, enabled]);

  return { status, kind };
}
